import { useMutation } from "@tanstack/react-query";
import { ResetPasswordPayload } from "src/business/password";
import { getVersionedUrl } from "src/Utils/API";

export const useResetPassword = (onSuccess?: () => void, onError?: (error: Error) => void) => {
  return useMutation({
    mutationFn: async (payload: ResetPasswordPayload) => {
      const response = await fetch(`${getVersionedUrl()}/password/reset`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!data.success) {
        throw new Error(data.error || "Failed to reset password");
      }
      return data;
    },
    onSuccess,
    onError,
  });
};
